/**
 * PWA service-worker registration.
 * We register only in production builds (CRA sets NODE_ENV=production for
 * `yarn build`). Dev previews stay non-cached so hot-reload works.
 */
export function registerPwa() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[PWA] SW registration failed:", err));
  });
}
